module.exports = __webpack_public_path__ + "static/model-simple.11f12484685848d9828c4669ecce5f4f.svg";